module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT__"
// module id = patternfly-react
// module chunks = 32